import React, { useState, useCallback, useEffect } from 'react';
import { usePrevious } from "../hooks";
import { Button, LegacyStack, Popover, TextField, ColorPicker, hsbToRgb, rgbToHsb, rgbString } from '@shopify/polaris';

export function ColorPickerCustom(props) {

    const rgbStringToHsb = function (value) {
        if (!value) {
            return { hue: 0, brightness: 0, saturation: 0, alpha: 1 };
        }

        var rgbValues;
        if (value.startsWith('#')) {
            var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
            value = value.replace(shorthandRegex, function (m, r, g, b) { return r + r + g + g + b + b; });
            rgbValues = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(value);
            if (!rgbValues) { rgbValues = [""]; }
            return rgbToHsb({
                red: parseInt(rgbValues[1], 16),
                green: parseInt(rgbValues[2], 16),
                blue: parseInt(rgbValues[3], 16),
                alpha: 1
            });
        }
        else {
            rgbValues = value.replace(/[^\d*.?\d*,]/g, "").split(",");
            return rgbToHsb({
                red: parseFloat(rgbValues[0]),
                green: parseFloat(rgbValues[1]),
                blue: parseFloat(rgbValues[2]),
                alpha: parseFloat(rgbValues[3])
            });
        }
    }

    const [active, setActive] = useState(false);
    const [hsbColor, setHsbColor] = useState(rgbStringToHsb(props.value));
    const [color, setColor] = useState(props.value);

    const prevValue = usePrevious(color);

    const handlePopoverOpen = useCallback(
        () => setActive(true),
        [],
    );

    const handlePopoverClose = useCallback(
        () => setActive(false),
        [],
    );

    const handleColorChange = useCallback(
        (newValue) => {
            newValue.alpha = parseFloat(newValue.alpha.toFixed(4));
            var rgbaColor = rgbString(hsbToRgb(newValue));
            setHsbColor(newValue);
            setColor(rgbaColor);

            props.handleChange(props.fieldName, rgbaColor);
        },
        // eslint-disable-next-line
        [],
    );

    const handleColorStringChange = useCallback(
        (newValue) => {
            var color = rgbStringToHsb(newValue);
            setHsbColor(color);
            setColor(newValue);

            props.handleChange(props.fieldName, newValue);
        },
        // eslint-disable-next-line
        [],
    );

    useEffect(() => {
        if (prevValue !== props.value) {
            handleColorStringChange(props.value);
        }
    });

    const activator = (
        <Button onClick={handlePopoverOpen} fullWidth={true} textAlign="left">
            <LegacyStack alignment="center" spacing="tight">
                <div className="color-picker-indicator" style={{ background: color }} />
                <span>{color}</span>
            </LegacyStack>
        </Button>
    );

    return (
        <div>
            <div className="Polaris-Labelled__LabelWrapper"><div className="Polaris-Label"><label className="Polaris-Label__Text">{props.label}</label></div></div>
            <Popover
                active={active}
                activator={activator}
                onClose={handlePopoverClose}
            >
                <Popover.Section>
                    <ColorPicker
                        onChange={(newValue) => handleColorChange(newValue)}
                        color={hsbColor}
                        allowAlpha
                    />
                </Popover.Section>
                <Popover.Section>
                    <TextField
                        value={color}
                        onChange={(newValue) => handleColorStringChange(newValue)}
                    />
                </Popover.Section>
            </Popover>
        </div>
    );
}